module.exports = __webpack_public_path__ + "img/coupons-empty-red.49cca9b9.svg";